import { Box } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import InError from 'components/error'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import Loading from 'components/loading'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import WrapperWithHeader from 'components/wrapper-with-header'
import { useAuth } from 'contexts/auth'
import { IProjectDTO, ISnowFlakeTableDTO } from 'data/dtos/automation/i-project-dto'
import { loadItem } from 'services/requests'
import { captalize } from 'utils/captalize'
import { encryptProjectTableData } from 'utils/streamlit/functions'
import { generateTablePreviewUrl } from 'utils/streamlit/url'
import AdesaoCustomTable from '../adesao-custom-table/ index'
import { useStyles } from './styles'

interface TablePreviewStreamlitProps {
  snowflakeTableId: string
  organizationId: string
  projectId: string
  project: IProjectDTO
}

const TablePreviewStreamlit = ({
  organizationId,
  project,
  projectId,
  snowflakeTableId,
}: TablePreviewStreamlitProps) => {
  const { token } = useAuth()
  const { VITE_APP_AMBIENT } = import.meta.env

  const classes = useStyles()

  const { isLoading, data, isError } = useQuery({
    queryKey: ['snowflake-tables', snowflakeTableId],
    queryFn: () => loadItem('/snowflake-tables', snowflakeTableId),
    enabled: snowflakeTableId != null,
  })

  if (isLoading) {
    return (
      <WrapperWithHeader>
        <Box className={classes.root}>
          <Loading />
        </Box>
      </WrapperWithHeader>
    )
  }

  if (isError) {
    return (
      <WrapperWithHeader>
        <InError message='Error ao Carregar a Tabela' />
      </WrapperWithHeader>
    )
  }

  const snowFlakeTableData = data.data.data as ISnowFlakeTableDTO
  const organizationName = project.organizationOutput?.corporateName
  const backRoute = `/projects/${projectId}/${organizationId}`
  const tableLable = `Tabela: ${captalize(snowFlakeTableData.label)}`

  if (snowFlakeTableData.name == 'campanha_de_adesao' && VITE_APP_AMBIENT !== 'prod') {
    return (
      <AdesaoCustomTable
        tableLabel={tableLable}
        backRoute={backRoute}
        organizationName={organizationName}
        projectIsInactive={project.isInactive}
      />
    )
  }

  const streamlitUrl = generateTablePreviewUrl(
    encryptProjectTableData({
      jwt: token,
      snowflakeTableId: snowflakeTableId,
      organizationOutputId: project.organizationOutput.id,
    })
  )

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title
          text={tableLable}
          backRoute={backRoute}
        />
      </Header>
      <Page>
        <Box className={classes.root}>
          <Box className={classes.card}>
            <iframe
              className={classes.iframe}
              src={streamlitUrl}
            ></iframe>
          </Box>
        </Box>
      </Page>
    </Wrapper>
  )
}

export default TablePreviewStreamlit
